import { useState } from 'react'
import Layout from 'shared/layouts/containers/Main'
import useInit from './hooks/useInit'
import DeleteModal from 'shared/components/DeleteModal'
import { pageSizes, defaultPageSize, apiUrls, tableColumnWidths, roles, settings } from 'consts'
import getRows from './utils/getRows'
import {
  PagingState,
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  SortingState,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
  PagingPanel,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import SearchPanelInput from 'shared/components/SearchPanelInput'
import Footer from 'shared/components/Footer'
import showCustomerSwitcher from 'utils/showCustomerSwitcher'
import getPageSize from 'utils/getPageSize'

const Sites: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [deleteEntryId, setDeleteEntryId] = useState<boolean | number>(false)

  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const canEditAndDelete = hasAnyRole([roles.admin, roles.superAdmin])

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'action', title: 'Actions', encodeHtml: false },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'id', width: tableColumnWidths.id },
    { columnName: 'name', width: 'auto' },
    { columnName: 'action', width: tableColumnWidths.action },
  ]

  if (!canEditAndDelete) {
    columns.pop()
    columnWidths.pop()
  }

  useInit({
    getRows,
    setRows,
    setDeleteEntryId,
    setShowModal,
    setShowOverlay,
    currentCustomer,
  })

  const isAdmin: boolean = hasAnyRole([roles.admin, roles.superAdmin])

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='with-action' />
  )

  const SearchPanelInputComponent = (props) => {
    return SearchPanelInput({
      addUrl: isAdmin ? '/add-site' : undefined,
      addText: isAdmin ? 'Add Site' : undefined,
      inputProps: props,
    })
  }

  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showMinimizedBarButton={true}
      showOverlay={showOverlay}
      headerInsert={
        showCustomerSwitcher() ? (
          <HeaderCustomerSelect
            setShowOverlay={setShowOverlay}
            handleCustomerChanged={(customer) => setCurrentCustomer(customer)}
          />
        ) : undefined
      }
    >
      <>
        <Grid rows={rows} columns={columns}>
          <SortingState defaultSorting={[{ columnName: 'name', direction: 'asc' }]} />
          <SearchState defaultValue='' />
          <IntegratedFiltering />
          <IntegratedSorting />
          <PagingState
            defaultCurrentPage={0}
            defaultPageSize={getPageSize(settings.pageSizeSites)}
          />
          <IntegratedPaging />
          <Toolbar />
          <SearchPanel inputComponent={SearchPanelInputComponent} />
          <Table tableComponent={TableComponent} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
          <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />
        </Grid>
        <DeleteModal
          url={apiUrls.sites}
          showModal={showModal}
          setShowModal={setShowModal}
          deleteEntryId={deleteEntryId}
          setDeleteEntryId={setDeleteEntryId}
          entityName='Site'
          getRows={getRows}
          setRows={setRows}
        />
      </>
    </Layout>
  )
}

export default Sites
